import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { formatDate, formatRp } from "@/lib/api";
import { StatusBadge } from "@/components/shop/StatusBadge";
import { PageHeader } from "@/pages/admin/AdminLayout";

const Kpi = ({ label, value, testId }) => (
  <div className="p-4"><p className="text-xs text-stone-500">{label}</p><p className="tnum mt-1 text-2xl font-semibold" data-testid={testId}>{value}</p></div>
);

export default function AdminDashboard() {
  const call = useApi();
  const [d, setD] = useState(null);
  useEffect(() => { call("get", "/admin/dashboard").then(setD); }, [call]);
  if (!d) return <p className="text-sm text-stone-500">Memuat...</p>;
  const c = d.counts;
  return (
    <div>
      <PageHeader title="Dashboard"><Link to="/admin/pesanan" className="rounded-md bg-amber-700 px-4 py-2 text-sm font-medium text-white hover:bg-amber-800" data-testid="dashboard-orders-button">Proses Pesanan</Link></PageHeader>
      <div className="grid grid-cols-2 divide-x divide-y divide-stone-200 rounded-lg border border-stone-200 bg-white md:grid-cols-4 md:divide-y-0">
        <Kpi label="Pesanan hari ini" value={d.today_orders} testId="kpi-today-orders" />
        <Kpi label="Pendapatan hari ini" value={formatRp(d.today_revenue)} testId="kpi-today-revenue" />
        <Kpi label="Laba bersih hari ini" value={formatRp(d.today_profit)} testId="kpi-today-profit" />
        <Kpi label="Perlu dikemas (Paid)" value={c.paid} testId="kpi-paid" />
      </div>
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-5" data-testid="status-pipeline">
        {["pending", "paid", "packed", "shipped", "completed"].map((s) => (
          <Link key={s} to={`/admin/pesanan?status=${s}`} className="rounded-lg border border-stone-200 bg-white p-4 hover:border-amber-700/50">
            <StatusBadge status={s} /><p className="tnum mt-2 text-xl font-semibold" data-testid={`pipeline-count-${s}`}>{c[s]}</p>
          </Link>
        ))}
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <div className="rounded-lg border border-stone-200 bg-white lg:col-span-2">
          <p className="border-b border-stone-200 p-4 font-semibold">Pesanan terbaru</p>
          {d.recent.length === 0 ? <p className="p-4 text-sm text-stone-500">Belum ada pesanan masuk.</p> : d.recent.map((o) => (
            <div key={o.order_id} className="flex items-center gap-3 border-b border-stone-100 px-4 py-3 text-sm last:border-0">
              <div className="flex-1"><p className="font-medium">{o.order_id}</p><p className="text-xs text-stone-500">{o.sender.name} · {formatDate(o.created_at)}</p></div>
              <span className="tnum">{formatRp(o.total)}</span><StatusBadge status={o.status} />
            </div>
          ))}
        </div>
        <div className="rounded-lg border border-stone-200 bg-white">
          <p className="border-b border-stone-200 p-4 font-semibold">Stok menipis (≤ 5)</p>
          {d.low_stock.length === 0 ? <p className="p-4 text-sm text-stone-500">Semua stok aman.</p> : d.low_stock.map((p) => (
            <div key={p.id} className="flex justify-between border-b border-stone-100 px-4 py-3 text-sm last:border-0"><span>{p.name}</span><span className="tnum font-medium text-amber-800">{p.stock}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
}
